<template>
  <div class="answer" flex="main:center" v-loading="loading">
    <xmlNavBack v-if="!$store.getters.isLayout" />
    <div class="answer-page" flex="cross:top">
      <!-- <div class="answer-page--sidebar datijieguo">
        <div class="dot-title no-border" style="margin-top: 20px">答题卡</div>
        <div class="sidebar-content" style="flex: 1; min-height: 0">
          <div class="moduleContent" style="flex: 1; min-height: 0">
            <div class="module" v-for="(
module, moduleIndex
              ) in testPaperDetail.testPaperModuleList" :key="module.id">
              <div class="module-name">
                {{ moduleIndex + 1 }}、{{ module.moduleName }}
              </div>

              <div class="module-question">
                <div class="question-seq" v-for="(question, questionIndex) in module.questionList" :key="questionIndex">
                  <div class="question-seq--item" :class="getQuestionStatus(question)"
                    @click="toQuestion(moduleIndex, questionIndex)">
                    {{ questionIndex + 1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="padding: 20px 0; border-top: 1px solid #f2f2f2">
            <div flex class="tips">
              <div class="tips-item" flex="cross:center">
                <div class="status true"></div>
                <div class="text">正确</div>
              </div>

              <div class="tips-item" flex="cross:center">
                <div class="status false"></div>
                <div class="text">错误</div>
              </div>
              <div class="tips-item" flex="cross:center">
                <div class="status answer"></div>
                <div class="text">未判错</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class=" answer-page--newsidebar datijieguo" flex="dir:top">
        <div class="dot-title-new no-border">答题卡
          <div class="answser-back"></div>
        </div>
        <div class="white-back">

          <!-- <div class="count-down">
            <span>本次考试分数：</span>
            <span style="color: #ff5353">{{ testPaperRecord.answerScore || 0 }}分</span>
          </div> -->
          <div style="border-bottom: 1px solid rgba(26,26,26,0.08);">
            <div flex class="tips">
              <div class="tips-item" flex="cross:center">
                <div class="status true"></div>
                <div class="text">正确 <span style="margin-left: 5px;">{{ testInfo.answerYesCount }}</span></div>
              </div>

              <div class="tips-item" flex="cross:center">
                <div class="status false"></div>
                <div class="text">错误 <span style="margin-left: 5px;">{{ testInfo.answerWrongCount }}</span></div>
              </div>

              <div class="tips-item" flex="cross:center">
                <div class="status answer"></div>
                <div class="text">未判错 <span style="margin-left: 5px;">{{ testInfo.answerNotJudgedCount }}</span></div>
              </div>
            </div>
          </div>

          <div class="sidebar-content" style="flex: 1; min-height: 0" flex="dir:top">
            <div class="moduleContent" style="flex: 1; min-height: 0; overflow-x: hidden;">
              <div class="module" v-for="(
module, moduleIndex
              ) in testPaperDetail.testPaperModuleList" :key="module.id">
                <div class="module-name">
                  {{ moduleIndex + 1 }}.{{ module.moduleName }}
                </div>

                <div class="module-question">
                  <div class="question-seq" v-for="(question, questionIndex) in module.questionList"
                    :key="questionIndex">
                    <div class="question-seq--item" :class="getQuestionStatus(question)"
                      @click="toQuestion(moduleIndex, questionIndex)">
                      {{ questionIndex + 1 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="answer-page--main" flex="dir:top">
        <!-- <div class="finish_time">
          恭喜您用时 <span>{{ timeUse }}</span> 完成考试！
        </div>
        <div class="result_flex">
          <div>
            答对<span style="color: #52ba2a">{{
              testInfo.answerYesCount
            }}</span>
          </div>
          <div>
            答错
            <span style="color: #666666">{{ testInfo.answerWrongCount }}</span>
          </div>
          <div>
            未判错
            <span style="color: #2e9adb">
              {{ testInfo.answerNotJudgedCount }}</span>
          </div>
        </div>
        <div style="padding: 20px 40px">
          <div class="result_title">试卷详情</div>
          <div class="result_intro">
            <div>学科：{{ testPaperDetail.subjectName }}</div>
            <div>
              考试时长：
              {{
                testPaperDetail.testDuration
                  ? testPaperDetail.testDuration + "分钟"
                  : "不限时"
              }}
            </div>
            <div>题目数量：{{ questionNum }}</div>
          </div>
        </div>

        <div class="testPaper-title">
          {{ testPaperDetail.paperName }}自测结果
        </div> -->

        <div class="paper-detail">
          <div class="answer-back"></div>
          <div class="top-box">
            <div class="top-box-left">
              <div class="congluation">恭喜您完成考试！</div>
              <div class="time">
                <div class="text">本次答题用时</div>
                <div class="back-text" style="margin-right: 10px;">
                  <div style="display: flex; justify-content: center; font-size: 16px; line-height: 21px;">
                    <div v-if="hour && hour != '0'" class="time-item">
                      <span style="white-space: nowrap;">{{ hour }}</span>&nbsp;时
                    </div>
                    <div v-if="minute && minute != '0'" class="time-item">
                      <span style="white-space: nowrap;">{{ minute }}</span>&nbsp;分
                    </div>
                    <div v-if="second && second != '0'" class="time-item">
                      <span style="white-space: nowrap;">{{ second }}</span>&nbsp;秒
                    </div>
                    <div v-if="(!hour || hour == '00') && (!minute || minute == '00') && (!second || second == '00')"
                      style="position: relative; z-index: 11;" class="time-item">
                      <span style="white-space: nowrap;">0</span>&nbsp;秒
                    </div>
                  </div>
                  <div class="text-back"></div>
                </div>
                <!-- <div class="text">本次答题分数(不含主观题)</div>
                <div class="back-text">
                  <div style="display: flex; justify-content: center; font-size: 16px; line-height: 21px;">
                    <div class="time-item">
                      <span>{{ testPaperRecord.answerScore }}</span>&nbsp;分
                    </div>
                  </div>
                  <div class="score-back"></div>
                </div> -->
              </div>
            </div>
            <div class="top-box-right">
              <div class="num-item right">
                <div class="err-item">{{ testInfo.answerWrongCount }}</div>
                <div class="err-ring"></div>
                <div class="num-text">答错</div>
              </div>
              <div class="num-item error">
                <div class="right-item"> {{ testInfo.answerYesCount }}</div>
                <div class="right-ring"></div>
                <div class="num-text">答对</div>
              </div>
              <div class="num-item answer">
                <div class="answer-item">{{ testInfo.answerNotJudgedCount }}</div>
                <div class="answer-ring"></div>
                <div class="num-text">未判错</div>
              </div>
            </div>
          </div>
          <div class="test-detail">
            <div class="detail-item">
              <div class="logo"><img src="../../../assets/images/detail-type.png" alt="">教学属性</div>
              {{ goodsDetail.teachPropertyAllStr == null ||
                goodsDetail.teachPropertyAllStr == ""
                ? "-"
                : goodsDetail.teachPropertyAllStr}}
            </div>
            <div class="detail-item">
              <div class="logo"><img src="../../../assets/images/detail-subject.png" alt=""> 学科</div>
              {{ testPaperDetail.subjectName }}
            </div>
            <div class="detail-item">
              <div class="logo"><img src="../../../assets/images/detail-time.png" alt=""> 考试时长</div>
              {{
                testPaperDetail.testDuration
                  ? testPaperDetail.testDuration + "分钟"
                  : "不限时"
              }}
            </div>

          </div>
          <div class="test-detail">
            <div class="detail-item">
              <div class="logo"><img src="../../../assets/images/detail-num.png" alt=""> 题目数量</div>
              {{ testPaperDetail.questionNum }}
            </div>
            <!-- <div class="detail-item">
              <div class="logo"><img src="../../../assets/images/detail-score.png" alt=""> 满分</div>
              {{ testPaperDetail.fullMark }}
            </div>
            <div class="detail-item">
              <div class="logo"><img src="../../../assets/images/detail-pass.png" alt="">及格分</div>
              {{ testPaperDetail.passMark }}
            </div> -->
          </div>
          <!-- <div class="know_box">
            <div class="know_back"></div>
            <div class="know_logo">
              <div class="text">知识点</div>

              <div class="logo"></div>
            </div>
            <div v-if="!testPaperDetail.knowledgePoints ||
              !testPaperDetail.knowledgePoints.length ||
              testPaperDetail.knowledgePoints[0] == null">
              <span>无</span>
            </div>
            <div v-else class="know_tag_box">
              <div class="know_tag" v-for="(item, index) in testPaperDetail.knowledgePoints" :key="item.id">
                {{ item.kpName }} <span v-show="index != testPaperDetail.knowledgePoints.length - 1"
                  style="margin: 0 3px;"> /</span>
              </div>
            </div>
          </div> -->
        </div>

        <div class="paper-back">
          <div class="test-detail">
            试卷详情
          </div>
          <div class="test_over">
            <div class="testPaper-title">{{ testPaperDetail.paperName }}</div>
            <div class="test-paper">
              <el-scrollbar style="height: 100%" wrap-class="test-paper-wrap" view-class="test-paper-view">
                <div>
                  <div class="paper-module" v-for="(module, moduleIndex) in testPaperDetail.testPaperModuleList"
                    :key="moduleIndex">
                    <div class="paper-module--name">
                      {{ changeNumToHan(moduleIndex + 1) }}、{{ module.moduleName }}（共{{ module.moduleQuestionNum }}道题{{
                        module.moduleScore ? `，共计${module.moduleScore}分` : ""
                      }}）
                    </div>
                    <div>
                      <bc-answer-question :dict="{ label: dict.label }"
                        :class="`answer-module-${moduleIndex}--question-${questionIndex}`"
                        v-for="(question, questionIndex) in module.questionList" :question="question"
                        :seq="questionIndex + 1" :key="questionIndex" :typeOk="typeOk"
                        :answerRecordList="answerQuestionRecordList" :testPaperDetailName="testPaperDetail.subjectName"
                        :answershow="false" :aishow="isShowAi ? 'true' : 'false'"
                        :isView="{ isViewAnswer: 0, isViewStatistics: 1 }" @openAi="openAi"
                        is-record></bc-answer-question>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>

      </div>
    </div>
    <robot v-show="isShowAi" ref="robotBox" :goodsId="goodsId" :bookName="bookdetail" />
  </div>
</template>

<script>
import { paperGetToken, getPaperIdApi } from "@/api/index/index";
import robot from "@/components/robot.vue";
import { robotBook } from "@/utils/config.js";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
import {
  getTestPaperDetail,
  testPaperAnalysisByAprId,
} from "@/api/answer/answer";
import XEUtils from "xe-utils";
import { isQuestionGroup } from "@/utils/questionType";
import xmlNavBack from '../components/xmlNavBack.vue'
export default {
  components: {
    robot, xmlNavBack
  },
  name: "answer-record",
  dicts: [
    "paper_type",
    "paper_generate_method",
    "examine_status",
    "difficulty",
    "question_type",
  ],
  data() {
    return {
      typeOk: "other", //false自测和true练习 其他other
      readtype: "", //阅读类型
      bookdetail: "建筑构造",
      goodsId: "",
      robotBook: "",
      showAi: "false",
      loading: false,
      ansRecordId: "",
      paperId: "",
      testInfo: {},
      testPaperDetail: {
        testPaperModuleList: [],
      },
      answerQuestionRecordList: [],
      testPaperRecord: {},
      timeUse: "",
      questionNum: "",
      paperList: [],
      rightNum: 0,
      wrongNum: 0,
      hour: '',
      minute: '',
      second: '',
      show: false,
      goodsDetail:{},
    };
  },
  computed: {
    isShowAi() {
      if (this.robotBook.includes(this.goodsId)) {
        return true
      }
      if (this.$store.getters.threePlatform == 'xueKeKnowledgeBaseSys') {
        return true
      }
      if (this.show) {
        return true
      }
      return false
    }
  },
  created() {
    this.robotBook = robotBook;
    this.ansRecordId = this.$route.query.ansRecordId;
    this.questionNum = this.$route.query.questionNum;
    this.goodsId = this.$route.query.goodsId;
    this.bookdetail = this.$route.query.bookdetail;
    let os = (function () {
      let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc,
      };
    })();
    if (os.isAndroid || os.isPhone) {
      // 手机
      console.log("手机");
      this.$router.replace({
        path: "/mobile-answer-record",
        query: this.$route.query,
      });
    } else if (os.isTablet) {
      // 平板
      console.log("平板");
      this.$router.replace({
        path: "/mobile-answer-record",
        query: this.$route.query,
      });
    } else {
      if (!this.ansRecordId) {
        this.$confirm("考试记录ID有误，请检查传入的考试记录ID", "提示", {
          closeOnClickModal: false,
          showClose: false,
          showCancelButton: false,
          closeOnPressEscape: false,
        }).then((res) => {
          if (res === "confirm") {
            window.close();
          }
        });
        return;
      }

      this.paperId = this.$route.query.paperId;
      if (!this.paperId) {
        this.$confirm("试卷ID有误，请检查传入的试卷ID", "提示", {
          closeOnClickModal: false,
          showClose: false,
          showCancelButton: false,
          closeOnPressEscape: false,
        }).then((res) => {
          if (res === "confirm") {
            window.close();
          }
        });
        return;
      }

      this.getDetail();
      this.testPaperAnaly();
    }
  },
  destroyed() { },
  mounted() {
    console.log(
      "🚀 ~ file: answer-record.vue:296 ~ mounted ~ this.showAi:",
      this.showAi
    );
    if (this.showAi == "true") {
      const data = {
        type: "showAi",
        value: true,
        code: "success",
      };
      // 向父vue页面发送信息
      window.parent.postMessage(
        {
          data,
        },
        "*"
      );
    }
    this.fixShowAi(this.goodsId)
    console.log("this.showAi:", this.showAi, this.show);
  },
  methods: {
    fixShowAi(id) {
      goodsInfoDetail(id).then((res) => {
        this.goodsDetail=res.data.goods
        if (res.code == 200 && res.data.xiaoZhi) {
          this.show = true
        }
        else {
          this.show = false
        }
      })
    },
    openAi(e) {
      var dataAi = e.replace(/<[^>]+>/g, "");
      this.$refs.robotBox.robotShwo = true;
      this.$refs.robotBox.sending(dataAi);
    },
    testPaperAnaly() {
      paperGetToken().then((token) => {
        testPaperAnalysisByAprId(
          {
            ansRecordId: this.ansRecordId,
          },
          token.data
        ).then((res) => {
          this.testInfo = res.data || {};
        });
      });
    },
    getQuestionStatus(question) {
      let record = this.answerQuestionRecordList.find(
        (i) => i.questionId === question.id
      );

      // console.log("question", question);
      // questionType 8音频/视频 9跟读题 13简答题
      let className = "isFalse";
      if (record) {
        console.log("record.answerSituation", record,question,this.answerQuestionRecordList);
        if (
          question.questionType != 8 &&
          question.questionType != 9 &&
          question.questionType != 13
        ) {
          className = record.answerSituation === "1" ? "isTrue" : "isFalse";
        } else {
          className =  record.answerSituation === "1" ? "isAnswer" : "isFalse";
        }
      } else {
        if (isQuestionGroup(question.questionType)) {
          let answerList = question.questionList.map((q) => {
            let answer = {
              answerResults: "",
              answerSituation: "0",
            };
            let obj = this.answerQuestionRecordList.find(
              (i) => q.id === i.questionId
            );

            if (obj) {
              answer.answerResults = obj.answerResults;
              answer.answerSituation = obj.answerSituation;
            }
            return answer;
          });
          let allTrue = answerList.every((i) => i.answerSituation === "1");
          className = allTrue ? "isTrue" : "isFalse";
        }
      }
      return className;
    },
    async getDetail() {
      this.loading = true;
      paperGetToken().then((token) => {
        getTestPaperDetail({
          paperId: this.paperId,
          ansRecordId: this.ansRecordId,
          token: token.data,
        }).then((res) => {
          this.testPaperDetail = res.data.tTestPaperDetailInfoVo;
          this.testPaperDetail.testPaperModuleList.map((item) => {
            this.paperList = this.paperList.concat(item.questionList);
          });
          this.questionNum = this.paperList.length;

          this.testPaperRecord = res.data.tAnswerPaperRecord;
          this.answerQuestionRecordList = res.data.answerQuestionRecordList;
          let timeUse = XEUtils.getDateDiff(
            this.testPaperRecord.testStartTime,
            this.testPaperRecord.testEndTime
          );
          let hour = timeUse.HH < 10 ? "" + timeUse.HH : timeUse.HH;
          let min = timeUse.mm < 10 ? "" + timeUse.mm : timeUse.mm;
          let sec = timeUse.ss < 10 ? "" + timeUse.ss : timeUse.ss;
          let format = "";
          if (timeUse.HH > 0) {
            format = `${hour}时${min}分${sec}秒`;
          }
          if (timeUse.HH <= 0) {
            format = `${min}分${sec}秒`;
          }
          if (timeUse.mm <= 0) {
            format = `${sec}秒`;
          }
          this.hour = hour;
          this.minute = min;
          this.second = sec;
          this.timeUse = format;
          this.loading = false;
        });
      });
    },
    toQuestion(moduleIndex, questionIndex) {
      const errorDiv = document.getElementsByClassName(
        `answer-module-${moduleIndex}--question-${questionIndex}`
      );
      errorDiv[0].scrollIntoView({ behavior: "auto" });
    },
    changeNumToHan(num) {
      let arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      let arr2 = [
        "",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
      ];
      if (!num || isNaN(num)) return "零";
      let english = num.toString().split("");
      let result = "";
      for (let i = 0; i < english.length; i++) {
        let des_i = english.length - 1 - i; // 倒序排列设值
        result = arr2[i] + result;
        let arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
      }
      result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十"); // 将【零千、零百】换成【零】 【十零】换成【十】
      result = result.replace(/零+/g, "零"); // 合并中间多个零为一个零
      result = result.replace(/零亿/g, "亿").replace(/零万/g, "万"); // 将【零亿】换成【亿】【零万】换成【万】
      result = result.replace(/亿万/g, "亿"); // 将【亿万】换成【亿】
      result = result.replace(/零+$/, ""); // 移除末尾的零
      // 将【一十】换成【十】
      result = result.replace(/^一十/g, "十");
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .text-break-all {
    p {
      img {
        max-width: 100px;
        max-height: 100px;
      }
    }
  }
}

.answer {
  width: 1400px;
  height: 100%;
  // background: #f2f2f2;
  margin: 0 auto;

  .testPaper-title {
    text-align: center;
    // padding: 18px;
    padding-top: 20px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 600;
    font-size: 20px;
    color: #27272A;
    line-height: 32px;
    // border-bottom: 1px solid #f2f2f2;
  }

  .answer-page {
    display: flex;
    padding-bottom: 20px;

    .answer-page--sidebar {
      width: 304px;
      background: #fffefd;
      border-radius: 6px;
      margin-right: 16px;
      max-height: 100%;
      display: flex;
      height: 850px;
      overflow: hidden;
      overflow-y: auto;
      flex-direction: column;

      .count-down {
        padding: 10px 20px 0;
      }

      .sidebar-content {
        .moduleContent {
          padding-bottom: 20px;
          flex: 1;
          min-height: 0;
          overflow-y: scroll;

          &::-webkit-scrollbar,
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 6px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          // 滚动条样式1
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 3px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          // 滚动条样式2
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          .submitBtn {
            width: 140px;
            background: #2e9adb;
            border-radius: 6px;
            margin: 0 auto;
            text-align: center;
            color: #fff;
            display: block;
          }

          .module {
            padding: 20px 20px 10px;

            &+.module {
              border-top: 1px solid #f2f2f2;
            }

            .module-name {
              font-size: 14px;
              color: #333333;
              margin-bottom: 15px;
            }

            .module-question {
              margin-left: -5px;
              margin-right: -5px;

              &::after,
              &::before {
                display: table;
                content: "";
              }

              &::after {
                clear: both;
              }

              .question-seq {
                padding-left: 6px;
                padding-right: 5px;
                float: left;
                margin-bottom: 10px;

                .question-seq--item {
                  width: 30px;
                  height: 21px;
                  line-height: 19px;
                  text-align: center;
                  background: #ffffff;
                  border: 1px solid #2e9adb;
                  //border-radius: 6px;
                  font-size: 14px;
                  color: #333333;
                  user-select: none;
                  cursor: pointer;
                  transition: all ease 0.3s;

                  &.isAnswer {
                    background: #2e9adb;
                    color: #fff;
                  }

                  &.isTrue {
                    border-color: #70b603;
                    background: #70b603;
                    color: #fff;
                  }

                  &.isFalse {
                    border-color: #d9001b;
                    color: #fff;
                    background: #d9001b;
                  }
                }
              }
            }
          }
        }
      }
    }

    .answer-page--newsidebar {

      .dot-title-new {
        padding: 13px 16px;
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 600;
        font-size: 14px;
        color: #27272A;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        border-radius: 12px 12px 0 0;
        border: #5F9BF4 1px solid;
        border-bottom: none;
      }

      // position: fixed;
      width: 304px;
      background: #BEDBFE;
      border-radius: 12px;
      margin-right: 16px;
      max-height: 100%;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);

      .dot-title-new {
        position: relative;
        border-right: none;
        border-left: none;

        .answser-back {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 16px;
          width: 50px;
          height: 50px;
          background-image: url(../../../assets/images/test-answer-back.png);
          background-position: center center;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }

      .white-back {
        height: calc(100% - 49px);
        overflow-y: auto;
        width: 100%;
        background: #FFFFFF;
        border-radius: 12px 12px 12px 12px;
        position: relative;
        padding: 16px;
        border-top: 1px solid #BEDBFE;

        // 隐藏滚动条但保留滚动功能
        &::-webkit-scrollbar {
          display: none; // 隐藏 webkit 浏览器的滚动条
        }

        scrollbar-width: none; // Firefox 隐藏滚动条
        -ms-overflow-style: none; // IE/Edge 隐藏滚动条
        // /* 隐藏滚动条 */
        // -ms-overflow-style: none;

        // /* 针对 IE 和 Edge */
        // &::-webkit-scrollbar-button {
        //   display: none;
        // }

        // // 滚动条变细
        // &::-webkit-scrollbar {
        //   width: 4px;
        //   display: block; // 确保滚动条显示
        // }

        // &::-webkit-scrollbar-thumb {
        //   border-radius: 2px;
        //   background: #c1c1c1;

        //   &:hover {
        //     background: #a8a8a8;
        //   }
        // }
        // scrollbar-width: thin;
        // scrollbar-color: #c1c1c1 transparent;


        .border {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          width: 100%;
          height: 64px;
          border: 1px solid;
          border-top: none;
          border-image: linear-gradient(180deg, #5F9BF4, rgba(255, 255, 255, 1)) 1 1;
        }
      }

      .count-down {
        padding: 10px 20px 0;
      }

      .sidebar-content {
        .moduleContent {
          padding-bottom: 20px;
          flex: 1;
          min-height: 0;
          // overflow-y: scroll;

          &::-webkit-scrollbar,
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 6px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          // 滚动条样式1
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 3px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          // 滚动条样式2
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          .submitBtn {
            width: 140px;
            background: #2e9adb;
            border-radius: 6px;
            margin: 0 auto;
            text-align: center;
            color: #fff;
            display: block;
          }

          .module {
            padding: 8px 2px;

            &+.module {
              // border-top: 1px solid #f2f2f2;
            }

            .module-name {
              font-size: 14px;
              padding: 8px;
              font-family: Microsoft YaHei UI, Microsoft YaHei UI;
              font-weight: 400;
              font-size: 14px;
              line-height: 18px;
              color: #27272A;
              text-align: left;
              font-style: normal;
              text-transform: none;
              color: #333333;
              margin-bottom: 16px;
              background: #FCFCFC;
              border-radius: 4px 4px 4px 4px;
            }

            .module-question {
              margin-left: -5px;
              margin-right: -5px;

              &::after,
              &::before {
                display: table;
                content: "";
              }

              &::after {
                clear: both;
              }

              .question-seq {
                padding-left: 6px;
                padding-right: 5px;
                float: left;
                margin-bottom: 10px;

                .question-seq--item {
                  width: 32px;
                  height: 32px;
                  line-height: 19px;
                  text-align: center;
                  background: #F4F4F5;
                  border-radius: 4px 4px 4px 4px;
                  user-select: none;
                  cursor: pointer;
                  transition: all ease 0.3s;
                  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                  font-weight: 400;
                  font-size: 14px;
                  color: #52525B;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  &.isAnswer {
                    background: #2e9adb;
                    color: #fff;
                  }

                  &.isTrue {
                    border-color: #18B451;
                    background: #18B451;
                    color: #fff;
                  }

                  &.isFalse {
                    border-color: #FF6565;
                    color: #fff;
                    background: #FF6565;
                  }
                }
              }
            }
          }
        }
      }
    }

    .answer-page--main {
      width: calc(100% - 320px);
      max-width: 1080px;
      height: 100%;
      border-radius: 6px;

      .paper-detail {
        background: #fffefd;
        padding: 30px 40px;
        margin-bottom: 20px;
        background: linear-gradient(180deg, #F2F7FF 0%, #F8FAFC 100%);
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
        border-radius: 12px 12px 12px 12px;
        position: relative;

        .answer-back {
          position: absolute;
          top: 35px;
          left: -5px;
          width: 54px;
          height: 54px;
          background-image: url(../../../assets/images/answer-back.png);
          background-position: center center;
          background-size: 54px 54px;
          background-repeat: no-repeat;
          z-index: 10;
          transform-origin: 0 0;
          transform: rotate(-45deg);
        }

        .top-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          z-index: 12;
          padding-bottom: 22px;
          border-bottom: 1px solid #E7E8EA;

          .top-box-left {
            .congluation {
              font-family: Microsoft YaHei UI, Microsoft YaHei UI;
              font-weight: bold;
              font-size: 20px;
              color: #27272A;
              line-height: 24px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              margin-bottom: 10px;
            }

            .time {
              display: flex;
              align-items: center;

              .text {
                font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                font-weight: 500;
                font-size: 16px;
                // color: #000000;
                color: #27272A;
                line-height: 24px;
                margin-right: 5px;
              }

              .back-text {
                font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                font-weight: 400;
                font-size: 16px;
                color: #27272A;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                // min-width: 160px;
                padding: 0 27px 0 18px;
                position: relative;
                z-index: 11;
                display: flex;
                align-items: center;
                flex-direction: column;

                .time-item {
                  position: relative;
                  z-index: 11;
                  display: flex;
                  align-items: center;
                  margin-right: 4px;
                  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                  font-weight: 600;
                  font-size: 16px;
                  color: #27272A;

                  span {
                    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                    font-weight: 600;
                    font-size: 26px;
                    color: #287CF7;
                    margin-right: 4px;

                  }
                }

                .text-back {
                  // width: 160px;
                  width: calc(100% + 45px);
                  height: 24px;
                  margin-top: -14px;
                  background-image: url(../../../assets/images/time-text.png);
                  background-position: center center;
                  background-size: 100% 100%;
                  background-repeat: no-repeat;
                  position: relative;
                  z-index: 10;
                  // font-size: 16px;
                }

                .score-back {
                  width: calc(100% + 45px);
                  height: 24px;
                  margin-top: -14px;
                  background-image: url(../../../assets/images/score_back.png);
                  background-position: center center;
                  background-size: 100% 100%;
                  background-repeat: no-repeat;
                  position: relative;
                  z-index: 10;
                }

              }
            }
          }

          .top-box-right {
            display: flex;

            .num-item {
              margin-left: 42px;
              width: 106px;
              padding: 8px 0px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              position: relative;

              .err-item,
              .answer-item,
              .right-item {
                font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                font-weight: 500;
                font-size: 18px;
                color: #FF3B30;
                text-align: center;
                font-style: normal;
                text-transform: none;
                line-height: 22px;
              }

              .right-item {
                color: #34C759;
              }

              .answer-item {
                color: #287CF7;
              }

              .num-text {
                font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                font-weight: 400;
                font-size: 14px;
                color: #52525B;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                line-height: 22px;
              }

              .err-ring {
                position: absolute;
                top: 19px;
                left: 0;
                right: 0;
                height: 18px;
                width: 100%;
                background-image: url(../../../assets/images/err-ring.png);
                background-position: center center;
                background-size: 100% 100%;
                background-repeat: no-repeat;
              }

              .right-ring {
                position: absolute;
                top: 19px;
                left: 0;
                right: 0;
                height: 18px;
                width: 100%;
                background-image: url(../../../assets/images/right-ring.png);
                background-position: center center;
                background-size: 100% 100%;
                background-repeat: no-repeat;
              }

              .answer-ring {
                position: absolute;
                top: 19px;
                left: 0;
                right: 0;
                height: 18px;
                width: 100%;
                background-image: url(../../../assets/images/answer-ring.png);
                background-position: center center;
                background-size: 100% 100%;
                background-repeat: no-repeat;
              }
            }
          }
        }



        .test-detail {
          display: flex;
          justify-content: space-between;
          padding: 22px 38px 0;

          .detail-item {
            // padding: 4px 0px 4px 10px;
            min-width: 150px;
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei UI, Microsoft YaHei UI;
            font-weight: 400;
            font-size: 14px;
            color: #27272A;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            line-height: 22px;
            // justify-content: center;
            position: relative;
            white-space: nowrap;

            .logo {
              // position: absolute;
              // top: 4px;
              // left: 0;
              font-family: Microsoft YaHei UI, Microsoft YaHei UI;
              font-weight: 400;
              font-size: 14px;
              color: #7A7A83;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              line-height: 22px;
              // padding-right: 4px;
              margin-right: 6px;
              display: flex;
              align-items: center;
              white-space: nowrap;

              img {
                margin-right: 4px;
                width: 16px;
                height: 16px;
                display: block;
              }
            }
          }

          // .detail-item:nth-child(2){
          //   justify-content: center;
          // }
          // .detail-item:last-child{
          //   justify-content: flex-end;
          // }
        }

        .know_box {
          background: linear-gradient(90deg, rgba(213, 238, 255, 0.6) 0%, rgba(255, 255, 255, 0.5) 100%);
          border-radius: 6px 6px 6px 6px;
          padding: 11px 111px;
          position: relative;

          .know_tag_box {
            display: flex;
            font-family: Microsoft YaHei UI, Microsoft YaHei UI;
            font-weight: 400;
            font-size: 14px;
            color: #27272A;
            line-height: 22px;
          }

          .know_back {
            position: absolute;
            top: -32px;
            left: -27px;
            width: 70px;
            height: 70px;
            background-image: url(../../../assets/images/know_logo.png);
            background-position: center center;
            // background-size: 57px 58px;
            background-repeat: no-repeat;
            display: flex;

          }

          .know_logo {
            position: absolute;
            top: 12px;
            left: 35px;
            font-family: Microsoft YaHei UI, Microsoft YaHei UI;
            font-weight: bold;
            font-size: 17px;
            color: #287CF7;
            line-height: 22px;
            z-index: 12;

            .text {
              position: relative;
              z-index: 12;
            }

            .logo {
              // width: 160px;
              width: calc(100% + 12px);
              height: 16px;
              // margin-top: -14px;
              background-image: url(../../../assets/images/know_back.png);
              background-position: center center;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              position: absolute;
              z-index: 10;
              bottom: -4px;
              left: -6px;
              // font-size: 16px;
            }
          }
        }
      }

      .paper-back {
        background: #ECF6FD;
        border-radius: 6px;

        height: calc(100% - 212px);

        // overflow-y:auto ;
        .test-detail {
          padding: 5px 27px;
          font-family: Microsoft YaHei UI, Microsoft YaHei UI;
          font-weight: 400;
          font-size: 14px;
          color: #52525B;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          position: relative;

          &::before {
            content: '';
            border-radius: 12px;
            width: 4px;
            height: 12px;
            position: absolute;
            top: calc(50% - 6px);
            left: 20px;
            background: linear-gradient(180deg, #5999F7 0%, #1872F6 100%);
          }
        }

        .test_over {
          height: calc(100% - 34px);
          overflow-y: auto;
          background: #fff;

          // 隐藏滚动条但保留滚动功能
          &::-webkit-scrollbar {
            display: none; // 隐藏 webkit 浏览器的滚动条
          }

          scrollbar-width: none; // Firefox 隐藏滚动条
          -ms-overflow-style: none; // IE/Edge 隐藏滚动条
        }
      }

      .record-desc {
        width: 1000px;
        height: 50px;
        line-height: 50px;
        margin: 0 auto;
        background: #f2f2f2;
        border-radius: 6px;
        justify-content: space-around;
      }

      .test-paper {
        flex: 1;
        min-height: 0;

        ::v-deep .test-paper-wrap {
          overflow-x: hidden;
        }

        ::v-deep .test-paper-view {
          padding: 0 10px;
        }

        .paper-module {
          padding: 20px 40px;

          &+.paper-module {
            border-top: 1px solid #f2f2f2;
            //margin-top: 20px;
          }

          .paper-module--name {
            margin-bottom: 24px;
            font-family: Microsoft YaHei UI, Microsoft YaHei UI;
            font-weight: bold;
            font-size: 16px;
            color: #27272A;
            line-height: 24px;
            font-family: Microsoft YaHei UI, Microsoft YaHei UI;
          }
        }
      }
    }
  }
}

.tags {
  line-height: 1;
  padding: 9px;
  font-size: 14px;
  color: #333333;
  background: #f2f2f2;
  border-radius: 6px;
  margin-right: 16px;
  margin-bottom: 10px;
}

.tips {
  padding: 0px 20px 0px;
  margin-bottom: 16px;
  display: flex;

  .tips-item {
    display: flex;
    margin-left: 20px;

    &:first-child {
      margin-left: 0px;
    }

    .status {
      width: 10px;
      height: 10px;

      &.true {
        background: #70b603;
      }

      &.false {
        background: #d9001b;
      }

      &.answer {
        background: #2e9adb;
      }
    }

    .text {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      margin-left: 6px;
    }
  }
}

::v-deep .question {
  .questionGroupContent {
    display: block;

    .questionType {
      display: inline-block;
    }

    .questionSeq,
    .questionScore {
      display: inline-block;
    }

    .content {
      display: inline;

      .stem-content {
        display: inline;

        .text-break-all {
          display: inline;

          p {
            //display: inline;
          }
        }
      }
    }
  }

  .group-content {
    display: inline;

    .question {
      padding-left: 20px;
    }
  }

  .stem {
    .stem-box {
      display: block;

      .questionType {
        display: inline-block;
      }

      .questionSeq,
      .questionScore {
        display: inline-block;
      }

      .content {
        display: inline;

        .stem-content {
          display: inline;

          .text-break-all {
            display: inline;

            p {
              //display: inline;
            }
          }
        }
      }
    }
  }

  .option-item {
    .questionType {
      display: inline-block;
    }

    .questionSeq,
    .questionScore {
      display: inline-block;
    }

    .content {
      display: block;

      .stem-content {
        display: block;

        .text-break-all {
          display: block;

          p {
            display: block;
          }
        }
      }
    }
  }
}

.dot-title {
  text-align: center;
  margin-top: 10px;
}

.finish_time {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  line-height: 52px;
  text-align: center;
  margin-top: 20px;

  span {
    font-size: 48px;
    color: #d9871f;
  }
}

.result_flex {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  width: 901px;
  height: 60px;
  background: #e5f5ff;
  border-radius: 6px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  line-height: 60px;
  margin: 20px auto;

  div {
    margin-right: 50px;
  }
}

.result_title {
  border-left: #2e9adb solid 4px;
  padding: 0 10px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
}

.result_intro {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 9px;
  margin-top: 20px;
}
</style>
